import React from "react";
import CSVReader from "react-csv-reader";
import GPAP_BUTTON, {
  GPAP_BUTTON_LIGHT,
} from "../../../../gpap-lib/Button_Collection";
import DoneIcon from "@material-ui/icons/Done";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import ReplayIcon from "@material-ui/icons/Replay";
import Grid from "@material-ui/core/Grid";
import { Tooltip } from "@material-ui/core";

import "./actionTable.css";
import Instructions from "../components/Instructions";

// TODO
// add a button to show an example of the filled rows

// FIXME
// The buttons for 
// adding +1 
// adding +10
// adding +100 
// rows are flaky

// ! Cypress tests are actually failing with:
// TypeError: Cannot read properties of undefined (reading '0')

// look for the function
// addRow

export class ActionTableSubmit extends React.Component {
  render() {
    return (
      <div className={"submit_toolbar"}>
        <Grid container justify="center" spacing={1}>
          <Grid item>
            <Tooltip title="Add 1 row to the table" placement="top">
              <GPAP_BUTTON id="addRow-1" onClick={this.props.addRow}>
                +1
              </GPAP_BUTTON>
            </Tooltip>
          </Grid>
          <Grid item>
            <Tooltip title="Add 10 rows to the table" placement="top">
              <GPAP_BUTTON id="addRow-10" onClick={this.props.addRow}>
                +10
              </GPAP_BUTTON>
            </Tooltip>
          </Grid>
          <Grid item>
            <Tooltip title="Add 100 rows to the table" placement="top">
              <GPAP_BUTTON id="addRow-100" onClick={this.props.addRow}>
                +100
              </GPAP_BUTTON>
            </Tooltip>
          </Grid>
          <Grid item>
            <Tooltip
              title="Validate the current data in the table"
              placement="top"
            >
              <GPAP_BUTTON
                id="validate"
                onClick={this.props.validate}
                startIcon={<DoneIcon />}
              >
                VALIDATE
              </GPAP_BUTTON>
            </Tooltip>
          </Grid>
          <Grid item>
            <Tooltip title="Submit the data" placement="top">
              <GPAP_BUTTON
                id="submit"
                startIcon={<CloudUploadIcon />}
                onClick={this.props.submit}
              >
                SUBMIT
              </GPAP_BUTTON>
            </Tooltip>
          </Grid>
          <Grid item lg={1}>
            <GPAP_BUTTON
              id="reload"
              onClick={this.props.reload}
              startIcon={<ReplayIcon />}
            >
              RELOAD
            </GPAP_BUTTON>
          </Grid>
          <Grid item lg={2}>
            <Instructions />
          </Grid>
          <Grid item lg={12}>
            <Grid container justify="center" spacing={3}>
              <Grid item lg={8}>
                <div className={"upload_container"}>
                  <div className={"text_tsv"}>
                    Upload data in TSV Format (tab separated)
                  </div>
                  <div style={{ float: "left" }}>
                    <CSVReader
                      style={{ float: "left" }}
                      cssClass="react-csv-input"
                      accept={".csv, .tsv, .txt"}
                      //cssInputClass="btn btn-success ml-2 my-2 my-sm-0 mr-1"
                      onFileLoaded={this.props.loadFile}
                    />
                  </div>
                  <Tooltip
                    title="Download a template to submit data"
                    placement="bottom"
                  >
                    <GPAP_BUTTON_LIGHT
                      style={{ float: "left" }}
                      id="addRow-100" // TO CHECK
                      onClick={this.props.getExcel}
                    >
                      DOWNLOAD TEMPLATE
                    </GPAP_BUTTON_LIGHT>
                  </Tooltip>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}
